import React from 'react';
import './style.css'

const Newsletter = (props) => {
  
    const submitHandler = (e) => {
        e.preventDefault()
    }

    return(
        <section className={`${props.nwclass} wpo-newsletter-section-2 `}>
            <div className="container">
                <div className="row">

                </div>
            </div>
        </section>
     )
        
}

export default Newsletter;
